
import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from '@Redux/type';
import { AppState } from '@Redux/store';
import { Titre1, Titre2, Titre3, Titre4, Titre5 } from './titre.component.styled';

type Enumerate<
	N extends number,
	Acc extends number[] = [],
> = Acc['length'] extends N
	? Acc[number]
	: Enumerate<N, [...Acc, Acc['length']]>;

export type IntRange<MIN extends number, MAX extends number> = Exclude<
	Enumerate<MAX>,
	Enumerate<MIN>
>;

type titrePropTypes = {
  texte: string;
  niveau: IntRange<1, 6>;
	className?: string | undefined;
};

const Titre: React.FC<Props> = ({
																	texte,
																	niveau,
																	className,
																}) => {
	switch (niveau) {
		case 2:
			return <Titre2 className={className}>{texte}</Titre2>;
		case 3:
			return <Titre3 className={className}>{texte}</Titre3>;
		case 4:
			return <Titre4 className={className}>{texte}</Titre4>;
		case 5:
			return <Titre5 className={className}>{texte}</Titre5>;
		default:
			return <Titre1 className={className}>{texte}</Titre1>;
	}
};

const mapStateToProps = (_: AppState, ownprops: titrePropTypes) => ({
	texte: ownprops.texte,
	niveau: ownprops.niveau,
	className: ownprops.className,
});

const mapDispatchToProps = (_: Dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Titre);

type Props = ReturnType<typeof mapDispatchToProps> &
	ReturnType<typeof mapStateToProps>